import { Grid, Card } from '@mui/material';
import { Loading } from "@gpstrackit/react-controls";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useDispatch } from 'react-redux';
//Views
import UserGadget from 'Modules/dashboard/views/.components/dashboardPanel/.components/userGadget';

//Actions
import { updateGadgetDashboardPanel } from 'Redux/actions'

//Styles
import './index.scss'

const DragDropContainer = (props) => {
    const dispatch = useDispatch();
    const { onDragEnd, dashboardSelected, columns, setColumns, windowDimensions, editMode, createEdit, deleteGadget, isEditable } = props

    const expandGadget = (item) => {
        let columnPanel = (item.columnPanel !== 2) ? 2 : 1;
        let newColumns = [];
        columns.map(function (column) {
            column.map((items, index) => {
                if (items.id === item.id) {
                    newColumns.push({ ...items, columnPanel})
                } else {
                    newColumns.push(items)
                }
            });
        });

        setColumns([newColumns])
        dispatch(updateGadgetDashboardPanel({
            id: item.id,
            dashboardId: item.dashboardId,
            name: item.name,
            type: item.type,
            settings: item.settings,
            columnOrder: item.columnOrder,
            refreshSeconds: item.refreshSeconds,
            columnPanel
        }));
    }

    return (
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start" className="drap-drop-container">
            <DragDropContext onDragEnd={result => onDragEnd(result, columns, setColumns)}>
                {!dashboardSelected?.name ? <Loading full show={false} /> : columns.map(function (column, columnId) {
                    return (
                        <Grid
                            item
                            sm={12}
                            xs={12}
                            key={columnId}
                            className="drap-drop-container-box"
                        >
                            <Droppable droppableId={`${columnId}`} key={columnId} className="drap-drop-container-box-droppable">
                                {(provided, snapshot) => {
                                    return (
                                        <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            style={{
                                                background: snapshot.isDraggingOver ? "lightblue" : "white",
                                                height: windowDimensions.height - 120,
                                            }}
                                            className="drap-drop-container-box-droppable-container"
                                        >
                                            {column.map((item, index) => {
                                                return (
                                                    <Draggable
                                                        key={item.id}
                                                        draggableId={`drag${item.id}`}
                                                        index={index}
                                                        isDragDisabled={!editMode}
                                                        className="drap-drop-container-box-droppable-container-draggable"
                                                    >
                                                        {(provided, snapshot) => {
                                                            return (
                                                                <Card
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className="dashboard_card"
                                                                    style={{
                                                                        margin: "10px",
                                                                        ...provided.draggableProps.style,
                                                                        transition: `all 100ms ease-out`,
                                                                        width: item.columnPanel == 2 ? 'calc(100% - 20px)' : 'calc(50% - 20px)',
                                                                        resize: 'none'
                                                                    }}
                                                                >
                                                                    <UserGadget item={item} createEdit={createEdit} editMode={editMode} expandGadget={expandGadget} deleteGadget={deleteGadget} isEditable={isEditable} />
                                                                </Card>
                                                            );
                                                        }}
                                                    </Draggable>
                                                );
                                            })}
                                            {provided.placeholder}
                                        </div>
                                    );
                                }}
                            </Droppable>
                        </Grid>
                    );
                })}
            </DragDropContext>
        </Grid>
    )
}

export default DragDropContainer